import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useState } from "react";
import { docsRepo } from "@/lib/repositories";
import { useDocsFilterStore } from "../stores";
import { useDebounce } from "@/hooks/useDebounce";

const PAGE_SIZE = 10;

export function useDocumentationsList() {
  const [page, setPage] = useState(1);
  const searchValue = useDocsFilterStore((s) => s.searchValue);
  const topicId = useDocsFilterStore((s) => s.topicId);
  const debouncedSearch = useDebounce(searchValue, 500);

  const [prevSearch, setPrevSearch] = useState(debouncedSearch);
  if (debouncedSearch !== prevSearch) {
    setPrevSearch(debouncedSearch);
    setPage(1);
  }

  const query = useQuery({
    queryKey: ["documentations", { page, search: debouncedSearch, topicId }],
    queryFn: () =>
      docsRepo.fetchDocumentations({
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
        search: debouncedSearch || undefined,
        topicId: topicId || undefined,
      }),
    placeholderData: keepPreviousData,
  });

  const documentations = query.data?.results ?? [];
  const pageCount = query.data ? Math.ceil(query.data.count / PAGE_SIZE) : 0;

  return {
    documentations,
    pageCount,
    page,
    setPage,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}
